<template>
  <div class="hold-transition">
    <div class="modal fade" id="modal-form-detalle-csservicio-nacional">
      <div class="modal-dialog modal-xl" v-if="servicio">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Detalle del Servicio</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 pt-2">
            <div class="p-3">
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">Información</h5>
                      <div class="card-tools">
                        <span
                          class="badge"
                          :class="
                            servicio.estado == 1
                              ? 'badge-secondary'
                              : servicio.estado == 2
                              ? 'badge-warning'
                              : servicio.estado == 3
                              ? 'bg-navy'
                              : servicio.estado == 4
                              ? 'bg-orange'
                              : servicio.estado == 5
                              ? 'badge-info'
                              : servicio.estado == 6
                              ? 'badge-success'
                              : 'bg-light'
                          "
                        >
                          {{ servicio.nEstado }}
                        </span>
                      </div>
                    </div>
                    <div class="card-body text-muted">
                      <div class="row mb-1">
                        <div class="col-md-5"># Servicio:</div>
                        <div class="col-md-7">
                          <strong>{{ servicio.id }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Tipo Servicio:</div>
                        <div class="col-md-7">
                          <strong>{{
                            servicio.nTipoServicio || postulacion.nTipoServicio || ""
                          }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Empresa:</div>
                        <div class="col-md-7">
                          <strong>{{ nombreEmpresa }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Fecha Inicial:</div>
                        <div class="col-md-7">
                          <strong>{{ servicio.fecha_ini || "" }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Fecha Final:</div>
                        <div class="col-md-7">
                          <strong>{{ servicio.fecha_fin || "" }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Trabajo realizado:</div>
                        <div class="col-md-7">
                          {{ servicio.trabajo_realizado || "" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">Equipo / Personal</h5>
                    </div>
                    <div class="card-body text-muted">
                      <div class="row mb-1">
                        <div class="col-md-5">Placa:</div>
                        <div class="col-md-7">
                          <strong>{{
                            postulacion.equipo ? postulacion.equipo.placa : ""
                          }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1" v-if="postulacion.remolque">
                        <div class="col-md-5">Remolque:</div>
                        <div class="col-md-7">
                          <strong>{{ postulacion.remolque.placa }}</strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">
                          {{
                            postulacion.persona_type == "App\\Conductor"
                              ? "Conductor"
                              : "Operario"
                          }}:
                        </div>
                        <div class="col-md-7">
                          <strong v-if="persona">
                            {{ persona.nombres }} {{ persona.apellidos }}
                            <span
                              class="badge badge-info"
                              v-if="persona.numero_documento"
                            >
                              {{ persona.numero_documento }}
                            </span>
                          </strong>
                        </div>
                      </div>
                      <div class="row mb-1" v-if="postulacion.aparejador">
                        <div class="col-md-5">Aparejador:</div>
                        <div class="col-md-7">
                          <strong>
                            {{ postulacion.aparejador.nombres }}
                            {{ postulacion.aparejador.apellidos }}
                          </strong>
                        </div>
                      </div>
                      <div class="row mb-1">
                        <div class="col-md-5">Día / Vh:</div>
                        <div class="col-md-7">
                          <strong>
                            {{ postulacion.pos_dia || "" }}
                            /
                            {{ postulacion.equipo_indice || "" }}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="card"
                v-if="
                  servicio.detalle_servicios &&
                    servicio.detalle_servicios.length > 0
                "
              >
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">Reporte de Trabajo</h5>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-bordered table-striped table-hover table-sm mb-0"
                    style="font-size: 0.85em"
                  >
                    <thead>
                      <tr>
                        <th class="text-center">Hora Inicio</th>
                        <th class="text-center">Hora Fin</th>
                        <th class="text-center">Tipo Tiempo</th>
                        <th>Observaciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="det in servicio.detalle_servicios"
                        :key="det.id"
                      >
                        <td class="text-center">{{ det.hora_ini }}</td>
                        <td class="text-center">{{ det.hora_fin }}</td>
                        <td class="text-center">{{ det.nTipoTiempo }}</td>
                        <td>{{ det.observaciones }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="card"
                v-if="servicio.presupuestos && servicio.presupuestos.length > 0"
              >
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">Presupuesto</h5>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-bordered table-striped table-hover table-sm mb-0"
                    style="font-size: 0.85em"
                  >
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>CECO / AFE</th>
                        <th>Funcionario</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="presup in servicio.presupuestos"
                        :key="presup.id"
                      >
                        <td>{{ presup.nTipoPresupuesto }}</td>
                        <td>
                          {{
                            presup.codigo_ceco_afe ||
                              (presup.ceco_afe
                                ? presup.ceco_afe.codigo || presup.ceco_afe.nombre
                                : "")
                          }}
                        </td>
                        <td>
                          {{
                            presup.ceco_afe && presup.ceco_afe.funcionario
                              ? presup.ceco_afe.funcionario.nombres +
                                " " +
                                presup.ceco_afe.funcionario.apellidos
                              : ""
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="card"
                v-if="servicio.firmas && servicio.firmas.length > 0"
              >
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">Firmas</h5>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-bordered table-striped table-hover table-sm mb-0"
                    style="font-size: 0.85em"
                  >
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                        <th>Observación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="firma in servicio.firmas" :key="firma.id">
                        <td>{{ firma.nTipoFirma }}</td>
                        <td>{{ firma.user ? firma.user.name : "" }}</td>
                        <td>{{ firma.fecha_firma }}</td>
                        <td>{{ firma.observacion }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CsServicioConsultaDetalle",
  data() {
    return {
      servicio: null,
      postulacion: {},
    };
  },
  computed: {
    persona() {
      return (
        (this.servicio && this.servicio.persona) ||
        this.postulacion.persona ||
        null
      );
    },
    nombreEmpresa() {
      if (this.servicio && this.servicio.empresa && this.servicio.empresa.razon_social) {
        return this.servicio.empresa.razon_social;
      }
      const tipo =
        this.postulacion.tipo_servicio || this.postulacion.tipoServicio || null;
      if (tipo && tipo.empresa && tipo.empresa.razon_social) {
        return tipo.empresa.razon_social;
      }
      const asignacion =
        this.postulacion.asignacion || this.postulacion.asignacion_nacional || null;
      if (asignacion && asignacion.empresa && asignacion.empresa.razon_social) {
        return asignacion.empresa.razon_social;
      }
      return "";
    },
  },
  methods: {
    llenarModal(postulacion) {
      this.postulacion = postulacion || {};
      this.servicio = postulacion && postulacion.servicio
        ? postulacion.servicio
        : null;
    },
  },
};
</script>
